import React, { memo } from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import Input from './Input'
import Keywords from './Keywords'
import { useSearchSubscription } from '../Context/SearchSubscriptionContext'

function Form({locale = 'en'}) {
  const { inputValue, handleChange } = useSearchSubscription()

  return (
    <div className="search-subscription__form-container">
      <div className="search-subscription__form">
        <Keywords />
      </div>

      <Divider />

      <div className="search-subscription__description">
        <Input value={inputValue} handleChange={handleChange} locale={locale} />
      </div>
    </div>
  )
}

Form.propTypes = {
  locale: string,
}

export default memo(Form)
